/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import moment from 'moment';
import * as types from './types';

export const state = {
  list: [],
  resources: [],
  loadingData: false,
  newInvoiceStatus: false,
  invoiceErrorStatus: false,
  invoiceErrorMessage: {},
  newLinkError: false,
  newLinkStatus: false,
  resourcesCount: 0,
  currentPage: 1,
  initialDate: moment().startOf('month').format('YYYY-MM-DD'),
  finalDate: moment().endOf('month').format('YYYY-MM-DD'),
  status: '',
  limitOptions: [10, 25, 50, 100],
  limit: 25,
  ordination: 'created_at_desc',
  subtotal: 0,
  filterVisible: false,
  link: '',
  invoice: {},

  subscription: {},
  subscriptions: {
    resources: [],
    loadingData: false,
    resourcesCount: 0,
    currentPage: 1,
    status: '',
    limitOptions: [50, 25, 10],
    limit: 25,
    ordination: 'created_at_desc',
  },

  eletronicPayment: {},
  eletronicPayments: {
    resources: [],
    loadingData: false,
    resourcesCount: 0,
    currentPage: 1,
    status: '',
    limitOptions: [50, 25, 10],
    limit: 25,
    ordination: 'created_at_desc',
  },
  newEletronicPayment: {},
  location: {},

  eletronicReceipt: {},
  eletronicReceipts: {
    resources: [],
    loadingData: false,
    resourcesCount: 0,
    currentPage: 1,
    status: '',
    limitOptions: [50, 25, 10],
    limit: 25,
    ordination: 'created_at_desc',
  },
  newEletronicReceipt: {},
};

export const mutations = {
  [types.LIST](state, list) {
    state.list = list;
  },

  [types.LINK](state, link) {
    state.link = link;
  },

  [types.FILTER_VISIBLE](state, status) {
    state.filterVisible = status;
  },
  [types.SUBTOTAL](state, subtotal) {
    state.subtotal = subtotal;
  },
  [types.RESOURCES](state, resources) {
    state.resources = resources;
  },
  [types.LIMIT](state, limit) {
    state.limit = limit;
  },
  [types.LOADING_DATA](state, status) {
    state.loadingData = status;
  },
  [types.NEW_INVOICE_STATUS](state, status) {
    state.newInvoiceStatus = status;
  },
  [types.INVOICE_ERROR_STATUS](state, status) {
    state.invoiceErrorStatus = status;
  },
  [types.INVOICE_ERROR_MESSAGE](state, status) {
    state.invoiceErrorMessage = status;
  },
  [types.RESOURCES_COUNT](state, count) {
    state.resourcesCount = count;
  },
  [types.CURRENT_PAGE](state, page) {
    state.currentPage = page;
  },
  [types.FILTER_INITIAL_DATE](state, date) {
    state.initialDate = date;
  },
  [types.FILTER_FINAL_DATE](state, date) {
    state.finalDate = date;
  },
  [types.FILTER_STATUS](state, status) {
    state.status = status;
  },
  [types.CURRENT_PAGE](state, newCurrentPage) {
    state.currentPage = newCurrentPage;
  },
  [types.SET_INVOICE_DATA](state, invoice) {
    state.invoice = invoice || {};
  },
  [types.NEW_LINK_STATUS](state, newLinkStatus) {
    state.newLinkStatus = newLinkStatus;
  },
  [types.NEW_LINK_ERROR](state, newLinkError) {
    state.newLinkError = newLinkError;
  },

  [types.SET_SUBSCRIPTIONS_RESOURCES](state, resources) {
    state.subscriptions.resources = resources;
  },
  [types.SET_SUBSCRIPTIONS_RESOURCES_COUNT](state, count) {
    state.subscriptions.resourcesCount = count;
  },
  [types.SET_SUBSCRIPTIONS_LOADING_DATA](state, response) {
    state.subscriptions.loadingData = response;
  },
  [types.SET_SUBSCRIPTIONS_CURRENT_PAGE](state, response) {
    state.subscriptions.currentPage = response;
  },
  [types.SET_SUBSCRIPTIONS_LIMIT](state, response) {
    state.subscriptions.limit = response;
  },
  [types.SUBSCRIPTION](state, subscription) {
    state.subscription = subscription;
  },
  [types.SUBSCRIPTION_SET](state, subscriptionSet) {
    state.subscriptionSet = subscriptionSet;
  },

  [types.SET_ELETRONIC_PAYMENTS_RESOURCES](state, resources) {
    state.eletronicPayments.resources = resources;
  },
  [types.SET_ELETRONIC_PAYMENTS_RESOURCES_COUNT](state, count) {
    state.eletronicPayments.resourcesCount = count;
  },
  [types.SET_ELETRONIC_PAYMENTS_LOADING_DATA](state, response) {
    state.eletronicPayments.loadingData = response;
  },
  [types.SET_ELETRONIC_PAYMENTS_CURRENT_PAGE](state, response) {
    state.eletronicPayments.currentPage = response;
  },
  [types.SET_ELETRONIC_PAYMENTS_LIMIT](state, response) {
    state.eletronicPayments.limit = response;
  },
  [types.ELETRONIC_PAYMENT](state, eletronicPayment) {
    state.eletronicPayment = eletronicPayment;
  },
  [types.NEW_ELETRONIC_PAYMENT](state, newEletronicPayment) {
    state.newEletronicPayment = newEletronicPayment;
  },
  [types.LOCATION](state, location) {
    state.location = location;
  },


  [types.SET_ELETRONIC_RECEIPTS_RESOURCES](state, resources) {
    state.eletronicReceipts.resources = resources;
  },
  [types.SET_ELETRONIC_RECEIPTS_RESOURCES_COUNT](state, count) {
    state.eletronicReceipts.resourcesCount = count;
  },
  [types.SET_ELETRONIC_RECEIPTS_LOADING_DATA](state, response) {
    state.eletronicReceipts.loadingData = response;
  },
  [types.SET_ELETRONIC_RECEIPTS_CURRENT_PAGE](state, response) {
    state.eletronicReceipts.currentPage = response;
  },
  [types.SET_ELETRONIC_RECEIPTS_LIMIT](state, response) {
    state.eletronicReceipts.limit = response;
  },
  [types.ELETRONIC_RECEIPT](state, eletronicPayment) {
    state.eletronicReceipt = eletronicPayment;
  },
  [types.NEW_ELETRONIC_RECEIPT](state, newEletronicReceipt) {
    state.newEletronicReceipt = newEletronicReceipt;
  },
};
